"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

//use this once you move it to component library
var AaLink = function AaLink(props) {
  var controls = props.controls || null;
  var config = controls && controls.config || {}; //onPress

  var customStyle = {};

  if (controls && controls.style) {
    customStyle = _StyleSheet["default"].create({
      custom: controls.style
    });
  }

  var styling = _StyleSheet["default"].flatten([defaultStyles.LinkContainer, customStyle.custom]);

  var _props$data = props.data,
      componentLabel = _props$data.componentLabel,
      url = _props$data.url;

  var onLinkPress = function onLinkPress(event) {
    event.preventDefault();

    if (_reactNativeWeb.Platform.OS === 'web') {
      window.open(url);
    } else {
      _reactNativeWeb.Linking.openURL(url);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styling
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
    onPress: onLinkPress
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: defaultStyles.LinkLabel
  }, componentLabel)));
};

var defaultStyles = _StyleSheet["default"].create({
  LinkContainer: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    web: {
      cursor: 'pointer'
    },
    textAlign: 'center'
  },
  LinkLabel: {
    fontSize: 14,
    color: "#1d1d1d",
    width: 'auto',
    web: {
      fontWeight: 400
    }
  }
});

var _default = AaLink;
exports["default"] = _default;